import { z } from 'zod'

import { TicketPriority } from './AreaPriorities'
import { Ticket, TicketStatus } from './Ticket'

export const AreaTickets = z.object({
  servedBy: z.number(),
  createdBy: z.number(),
  status: z.array(z.object({ status: TicketStatus, amount: z.number() })),
  tickets: z.object({
    content: z.array(Ticket),
    size: z.number(),
    totalElements: z.number(),
    totalPages: z.number(),
    page: z.number()
  })
})

export const ListAreaTicketsDTO = z.object({
  areaId: z.string(),
  month: z.number(),
  year: z.number(),
  search: z.string().optional(),
  subAreaId: z.string().optional(),
  responsibleId: z.string().optional(),
  complaintBy: z.string().optional(),
  responsible: z.array(z.string()).optional(),
  status: z.array(TicketStatus).optional(),
  priority: z.array(TicketPriority).optional(),
  page: z.number().optional(),
  size: z.number().optional()
})

export type ListAreaTicketsDTO = z.infer<typeof ListAreaTicketsDTO>
export type AreaTickets = z.infer<typeof AreaTickets>
